import Header from '../components/Header'
import Footer from '../components/Footer'

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <section className="gradient-bg text-white py-16">
        <div className="container-max section-padding text-center">
          <h1 className="text-4xl font-bold mb-4">Terms of Service</h1>
          <p className="text-blue-100 text-lg">Last updated: January 2025</p>
        </div>
      </section>
      <section className="py-16">
        <div className="container-max section-padding max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 space-y-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">1. Acceptance of Terms</h2>
              <p className="text-gray-600 leading-relaxed">By accessing or using MobiPay's services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">2. Use of Services</h2>
              <p className="text-gray-600 leading-relaxed">You agree to use MobiPay's services only for lawful purposes and in accordance with these terms. You are responsible for maintaining the confidentiality of your account credentials.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">3. Payment Processing</h2>
              <p className="text-gray-600 leading-relaxed">MobiPay acts as a payment facilitator. All transactions are subject to our processing fees as outlined in your merchant agreement. We reserve the right to hold or reverse transactions suspected of fraud.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">4. Prohibited Activities</h2>
              <p className="text-gray-600 leading-relaxed">You may not use our services for illegal activities, money laundering, or any activity that violates State Bank of Pakistan regulations. Violation of these terms may result in immediate account termination.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">5. Limitation of Liability</h2>
              <p className="text-gray-600 leading-relaxed">MobiPay shall not be liable for any indirect, incidental, or consequential damages arising from your use of our services. Our total liability shall not exceed the fees paid by you in the preceding three months.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">6. Governing Law</h2>
              <p className="text-gray-600 leading-relaxed">These terms are governed by the laws of Pakistan. Any disputes shall be resolved in the courts of Lahore, Pakistan.</p>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">7. Contact</h2>
              <p className="text-gray-600 leading-relaxed">For questions regarding these terms, contact us at <a href="mailto:support@mobipay.pk" className="text-orange-500 hover:underline">support@mobipay.pk</a>.</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  )
}

export default TermsOfServicePage
